const KEY = (site: string) => `mxch:${site}:consented`;

export function hasGivenConsent(site: string): boolean {
  return localStorage.getItem(KEY(site)) === "1";
}

export function recordConsent(site: string): void {
  localStorage.setItem(KEY(site), "1");
}

export function consentText(): { intro: string; accept: string; decline: string } {
  return {
    intro: "Hoi, ik ben Claudio — de digitale assistent van Maximilius. Wat je deelt komt bij ons team. Bij iets belangrijks zorg ik dat een collega contact met je opneemt. Akkoord met functionele cookies en dit gesprek?",
    accept: "Akkoord, laten we praten",
    decline: "Liever niet",
  };
}
